import React from "react";
import CircleLoader from "react-spinners/ClipLoader";

const SectionLoader = ({ size = 50 }) => {
  return (
    <div className="app-loader section">
      <CircleLoader color="#e3910a" size={size} aria-label="Loading" data-testid="loader" />
    </div>
  );
};

export default SectionLoader;
